import React, { useEffect } from 'react'
import Comment from './Comment'
import Additional from './Additional'

const Python = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  }, []);

  return (
    <div>
        <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
  <div className="container py-5">
    <div className="row g-5">
      <div className="col-lg-8">
        {/* Course Detail Start */}
        <div className="mb-5">
          <h1 className="mb-4">Python Programming</h1>
          <p>Explore the world of Python programming with our comprehensive course syllabus. This course is designed to provide you with practical experiences and hands-on projects to develop applications effectively. Our experienced trainers will guide you through each step of the journey, ensuring a thorough understanding of Python programming concepts.</p>
          <p>
            <b>Session 1: Introduction to Python</b>
          </p>
          <p>Introduction to Python, Setting up the Python environment</p>
          <b>Session 2: Variables and Data Types</b>
          <p>Variables, Basic Data Types, Type Conversion</p>
          <b>Session 3: Control Flow</b>
          <p>If statements, Loops (for, while), Conditional expressions</p>
          <b>Session 4: Functions</b>
          <p>Defining functions, Parameters, Return statements</p>
          <b>Session 5: Lists and Dictionaries</b>
          <p>Lists, List manipulation, Dictionaries and their usage</p>
          <b>Session 6: Object-Oriented Programming in Python</b>
          <p>Classes and objects, Inheritance, Encapsulation</p>
          <b>Session 7: Exception Handling</b>
          <p>Handling exceptions, Try-except blocks</p>
          <b>Session 8: File Handling</b>
          <p>Reading from and writing to files, File manipulation</p>
          <b>Session 9: Modules and Packages</b>
          <p>Creating and using modules, Organizing code with packages</p>
          <b>Session 10: Introduction to Libraries</b>
          <p>Exploring popular Python libraries like NumPy and Pandas</p>
        </div>
        {/* Blog Detail End */}
        {/* Comment List Start */}

        {/* Comment List End */}
        {/* Comment Form Start */}
        <Comment/>
        {/* Comment Form End */}
      </div>
      {/* Sidebar Start */}
      <div className="col-lg-4">
      <Additional/>
        {/* Plain Text End */}
      </div>
      {/* Sidebar End */}
    </div>
  </div>
</div>

    </div>
  )
}

export default Python